import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonUtil, Platform, CommonPlatformService } from 'psd-common';

@Component({
  selector: 'central-login-mail-verified',
  templateUrl: 'central-login-mail-verified.component.html'
})
export class CentralLoginMailVerifiedComponent implements OnInit {
  public currentPlatform: Platform = null;
  private prefix: string;
  private email: string;

  constructor(@Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private route: ActivatedRoute,
              private platformService: CommonPlatformService,
              private router: Router) {
  }

  ngOnInit() {
    this.renderer.addClass(this.document.body, 'login');

    this.route.queryParams.subscribe(_params => {
      this.prefix = _params.platform;
      this.email = _params.email;
      if(this.prefix) {
        this.platformService.getExternalPlatformDetails(this.prefix).subscribe(_platform => {
          this.currentPlatform = _platform;
        });
      }
    });
  }

  goToLogin() {
    this.router.navigate(['/central-login/login'], { queryParams: { 'platform' : this.prefix, 'email' : this.email } });
  }
}
